"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _common = require("../../common");

var _lib = require("../../lib");

var _Toggle = _interopRequireDefault(require("../Toggle"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj["default"] = obj;
    return newObj;
  }
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var Dimmer =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Dimmer, _PureComponent);

  function Dimmer() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Dimmer);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Dimmer)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "timer", null);

    _defineProperty(_assertThisInitialized(_this), "toggleRef", _react["default"].createRef());

    _defineProperty(_assertThisInitialized(_this), "wrapperRef", _react["default"].createRef());

    _defineProperty(_assertThisInitialized(_this), "dimmerRef", _react["default"].createRef());

    _defineProperty(_assertThisInitialized(_this), "resetCSS", function () {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        wrapper: true,
        dimmer: true
      };

      if (options.wrapper) {
        var wrapper = (0, _lib.getRefInstance)(_this.wrapperRef);

        if (wrapper) {
          var fullScreen = _this.props.fullScreen;

          if (!fullScreen) {
            wrapper.style.position = 'relative';
          }
        }
      }

      if (options.dimmer) {
        var dimmer = (0, _lib.getRefInstance)(_this.dimmerRef);

        if (dimmer) {
          var _fullScreen = _this.props.fullScreen;

          if (dimmer.onclick) {
            // add pointer cursor
            dimmer.style.cursor = 'pointer';
          }

          dimmer.style.position = _fullScreen ? 'fixed' : 'absolute';
          dimmer.style.width = '100%';
          dimmer.style.height = '100%';
          dimmer.style.top = 0;
          dimmer.style.left = 0;
          dimmer.style.background = 'rgba(1, 1, 1, 0.5)';
          dimmer.style.transition = _this.getTransition();
          dimmer.style.opacity = 0;
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "getTransition", function () {
      var duration = _this.props.duration;
      return "all ".concat(duration, "ms ease");
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnDim", function (e) {
      _this.resetCSS({
        dimmer: true
      });

      setTimeout(function () {
        var dimmer = (0, _lib.getRefInstance)(_this.dimmerRef);

        if (dimmer) {
          dimmer.style.opacity = 1;
        }

        var onDim = _this.props.onDim;
        onDim(e);
      }, 5);
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnUndim", function () {
      return _this.resetCSS({
        dimmer: true
      });
    });

    _defineProperty(_assertThisInitialized(_this), "dim", function (e) {
      var toggle = (0, _lib.getRefInstance)(_this.toggleRef);

      if (toggle) {
        if (_this.timer) {
          clearTimeout(_this.timer);
        }

        toggle.toggleOn(e);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "undim", function (e) {
      var duration = _this.props.duration;

      _this.handleOnUndim();

      _this.timer = setTimeout(function () {
        var toggle = (0, _lib.getRefInstance)(_this.toggleRef);

        if (toggle) {
          toggle.toggleOff(e);
        }
      }, duration + 1);
      var onUndim = _this.props.onUndim;
      onUndim(e);
    });

    _defineProperty(_assertThisInitialized(_this), "toggleDim", function (e) {
      var toggle = (0, _lib.getRefInstance)(_this.toggleRef);

      if (toggle) {
        if (toggle.state.active) {
          _this.undim(e);
        } else {
          _this.dim(e);
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "renderContent", function (_ref) {
      var active = _ref.active;
      var _this$props = _this.props,
          children = _this$props.children,
          fullScreen = _this$props.fullScreen;
      return (0, _lib.getRenderProps)(children, {
        wrapperRef: _this.wrapperRef,
        dimmerRef: _this.dimmerRef,
        dim: _this.dim,
        undim: _this.undim,
        toggle: _this.toggleDim,
        active: active,
        fullScreen: fullScreen
      });
    });

    return _this;
  }

  _createClass(Dimmer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.resetCSS();
      var active = this.props.active;

      if (active) {
        this.handleOnDim();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          active = _this$props2.active,
          toggleRef = _this$props2.toggleRef;
      var ref = this.toggleRef || toggleRef;
      return _react["default"].createElement(_Toggle["default"], {
        ref: ref,
        active: active,
        onToggleOn: this.handleOnDim,
        onToggleOff: this.handleOnUndim
      }, function (toggleProps) {
        return _this2.renderContent(toggleProps);
      });
    }
  }]);

  return Dimmer;
}(_react.PureComponent);

exports["default"] = Dimmer;

_defineProperty(Dimmer, "className", 'MHub-Dimmer');

_defineProperty(Dimmer, "propTypes", {
  children: _common.customPropTypes.render,
  active: _propTypes["default"].bool,
  duration: _propTypes["default"].number,
  toggleRef: _common.customPropTypes.ref,
  fullScreen: _propTypes["default"].bool,
  onDim: _propTypes["default"].func,
  onUndim: _propTypes["default"].func
});

_defineProperty(Dimmer, "defaultProps", {
  children: null,
  active: false,
  duration: 500,
  toggleRef: null,
  fullScreen: false,
  onDim: function onDim() {},
  onUndim: function onUndim() {}
});

_defineProperty(Dimmer, "Basic", function (_ref2) {
  var wrapperRef = _ref2.wrapperRef,
      dimmerRef = _ref2.dimmerRef,
      dim = _ref2.dim,
      undim = _ref2.undim,
      fullScreen = _ref2.fullScreen,
      toggle = _ref2.toggle,
      active = _ref2.active,
      rest = _objectWithoutProperties(_ref2, ["wrapperRef", "dimmerRef", "dim", "undim", "fullScreen", "toggle", "active"]);

  return active ? _react["default"].createElement("div", _extends({
    role: "presentation",
    ref: dimmerRef,
    onClick: undim,
    style: {
      zIndex: fullScreen ? 100 : null
    }
  }, rest)) : null;
});